import { Expose } from "class-transformer";

export default class Template {
  @Expose() content: string;
}
